'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import {
  initVisitorTracking,
  initCtaVisibilityTracking,
  initScrollToCtaTracking,
  claritySet,
} from '@/lib/analytics';

/**
 * Analytics initialization component
 * Handles visitor tracking, CTA visibility, and scroll-to-CTA tracking
 * Add this component to the root layout
 */
export default function AnalyticsInit() {
  const pathname = usePathname();

  // Initialize visitor tracking once on mount
  useEffect(() => {
    initVisitorTracking();
  }, []);

  // Track page type in Clarity and initialize CTA tracking on route change
  useEffect(() => {
    // Determine page type for Clarity segmentation
    let pageType = 'other';
    if (pathname === '/') {
      pageType = 'home';
    } else if (pathname.startsWith('/tools/')) {
      pageType = 'tool';
    } else if (pathname.startsWith('/blog/')) {
      pageType = 'blog';
    } else if (pathname.startsWith('/services/')) {
      pageType = 'service';
    } else if (pathname.startsWith('/industries/')) {
      pageType = 'industry';
    } else if (pathname.startsWith('/knowledge-base/')) {
      pageType = 'kb';
    } else if (pathname.startsWith('/software/')) {
      pageType = 'software';
    } else if (pathname === '/contact') {
      pageType = 'contact';
    }

    claritySet('page_type', pageType);

    // Initialize CTA visibility tracking
    const cleanupCtaVisibility = initCtaVisibilityTracking();
    const cleanupScrollToCta = initScrollToCtaTracking();

    return () => {
      cleanupCtaVisibility();
      cleanupScrollToCta();
    };
  }, [pathname]);

  return null;
}
